var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53553 10.9498L6 7.41429L2.46447 10.9498C2.07556 11.3387 1.43916 11.3387 1.05025 10.9498C0.661344 10.5609 0.661344 9.92452 1.05025 9.53561L4.58579 6.00008L1.05025 2.46455C0.661344 2.07564 0.661344 1.43924 1.05025 1.05033C1.43916 0.661424 2.07556 0.661425 2.46447 1.05033L6 4.58587L9.53553 1.05033C9.92444 0.661425 10.5608 0.661424 10.9497 1.05033C11.3387 1.43924 11.3387 2.07564 10.9497 2.46455L7.41421 6.00008L10.9497 9.53561C11.3387 9.92452 11.3387 10.5609 10.9497 10.9498C10.5608 11.3387 9.92444 11.3387 9.53553 10.9498Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8b9b126e0bfead95453d86181f2b51ea.svg";
export { ForwardRef as ReactComponent };